"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ImageUploader_vue_1 = __importDefault(require("@/Views/Components/Misc/ImageUploader.vue"));
var Pagination_vue_1 = __importDefault(require("@/Views/Components/Misc/Pagination.vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var route_1 = __importDefault(require("@/Modules/Misc/route"));
var PhoneNumber_vue_1 = __importDefault(require("../../../../Misc/PhoneNumber.vue"));
var routes_1 = require("@/routes");
var components = {
    ImageUploader: ImageUploader_vue_1.default,
    Pagination: Pagination_vue_1.default,
    PhoneNumber: PhoneNumber_vue_1.default
};
var BoardCreateUpdateForm = /** @class */ (function (_super) {
    __extends(BoardCreateUpdateForm, _super);
    function BoardCreateUpdateForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {
            image: null,
            name: "",
            code: "",
            abbr: "",
            email: "",
            phone: "",
        };
        _this.headers = [
            {
                text: "Name",
                value: "name",
            },
            {
                text: "Email",
                value: "email",
            },
            {
                text: "Role",
                value: "main_role.display_name"
            }
        ];
        _this.toggleBoardStatusDialog = false;
        _this.submitConfirmDialog = false;
        return _this;
    }
    Object.defineProperty(BoardCreateUpdateForm.prototype, "restrictInput", {
        get: function () {
            return this.board && this.board.is_main;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BoardCreateUpdateForm.prototype, "abbreviationChanged", {
        get: function () {
            return this.board && this.board.abbr !== this.form.abbr;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BoardCreateUpdateForm.prototype, "itemIndexRoute", {
        get: function () {
            return (0, route_1.default)(routes_1.BOARD_SPECIFIED_ITEM_INDEX_PAGE, {
                board: this.form.abbr,
                param: "all"
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BoardCreateUpdateForm.prototype, "adminItemIndexRoute", {
        get: function () {
            return (0, route_1.default)(routes_1.ADMIN_ITEM_INDEX_PAGE, {
                board: this.form.abbr
            });
        },
        enumerable: false,
        configurable: true
    });
    BoardCreateUpdateForm.prototype.toggleBoardStatus = function () {
        var _this = this;
        this.toggleBoardStatusDialog = false;
        this.$inertia.get((0, route_1.default)(routes_1.TOGGLE_BOARD_STATUS_ACTION, {
            board: this.board.abbr
        }), {}, {
            onSuccess: function (response) {
                var flash = response.props.flash;
                if (flash.messageColor == 'success') {
                    _this.$toast.success(flash.message);
                }
                else {
                    _this.$toast.error(flash.message);
                }
            },
            onError: function (error) {
                console.error(error);
            }
        });
    };
    BoardCreateUpdateForm.prototype.save = function () {
        var _this = this;
        if (this.abbreviationChanged && !this.submitConfirmDialog) {
            this.submitConfirmDialog = true;
        }
        else {
            var route = this.board ? (0, route_1.default)("admin.board.update", { board: this.board.abbr }) : (0, route_1.default)("admin.board.store");
            this.submitConfirmDialog = false;
            this.form.transform(function (data) { return (__assign(__assign({}, data), { image: data.image ? data.image.file : null })); }).post(route, {
                preserveState: true,
                onSuccess: function (response) {
                    var flash = response.props.flash;
                    _this.$toast.success(flash.message);
                },
                onError: function (error) {
                    console.error(error);
                }
            });
        }
    };
    BoardCreateUpdateForm.prototype.mounted = function () {
        if (this.board) {
            this.form.name = this.board.name;
            this.form.code = this.board.code;
            this.form.abbr = this.board.abbr;
            this.form.email = this.board.email;
            this.form.phone = this.board.phone;
        }
        this.form = this.$inertia.form(this.form);
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: Object, required: false })
    ], BoardCreateUpdateForm.prototype, "board", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: Object, required: true })
    ], BoardCreateUpdateForm.prototype, "currentRoute", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: String, required: true })
    ], BoardCreateUpdateForm.prototype, "routeName", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: Object, required: false })
    ], BoardCreateUpdateForm.prototype, "errors", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: Object, required: true })
    ], BoardCreateUpdateForm.prototype, "user", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: String, required: false })
    ], BoardCreateUpdateForm.prototype, "flashMessage", void 0);
    BoardCreateUpdateForm = __decorate([
        (0, vue_property_decorator_1.Component)({
            components: components
        })
    ], BoardCreateUpdateForm);
    return BoardCreateUpdateForm;
}(vue_property_decorator_1.Vue));
exports.default = BoardCreateUpdateForm;
